{
  "username": "使用者名稱",
  "password": "密碼",
  "login": "登入",
  "confirm": "確定",
  "cancel": "取消",
  "close": "關閉",
  "save": "儲存",
  "logout": "登出",
  "create": "建立",
  "add": "新增",
  "remove": "移除",
  "update": "更新",
  "copy": "複製",
  "copied": "已複製",
  "more": "更多",
  "download": "下載",
  "remark": "備註",
  "enable": "啟用",
  "protocol": "協議",
  "search": "搜尋",
  "filter": "篩選",
  "all": "全部",
  "from": "從",
  "to": "到",
  "done": "完成",
  "loading": "載入中...",
  "refresh": "重新整理",
  "clear": "清除",
  "second": "秒",
  "minute": "分鐘",
  "hour": "小時",
  "day": "天",
  "check": "檢視",
  "indefinite": "無限期",
  "unlimited": "無限制",
  "none": "無",
  "qrCode": "二維碼",
  "info": "更多資訊",
  "edit": "編輯",
  "delete": "刪除",
  "reset": "重置",
  "noData": "無數據。",
  "copySuccess": "複製成功",
  "sure": "確定",
  "encryption": "加密",
  "useIPv4ForHost": "使用 IPv4 連接主機",
  "transmission": "傳輸",
  "host": "主機",
  "path": "路徑",
  "camouflage": "混淆",
  "status": "狀態",
  "enabled": "開啟",
  "disabled": "關閉",
  "depleted": "耗盡",
  "depletingSoon": "即將耗盡",
  "offline": "離線",
  "online": "上線",
  "domainName": "域名",
  "monitor": "監聽",
  "certificate": "憑證",
  "fail": "失敗",
  "comment": "評論",
  "success": "成功",
  "lastOnline": "上次上線",
  "getVersion": "獲取版本",
  "install": "安裝",
  "clients": "客戶端",
  "usage": "使用情況",
  "twoFactorCode": "代碼",
  "remained": "剩餘",
  "security": "安全",
  "secAlertTitle": "安全警報",
  "secAlertSsl": "此連線不安全。在啟用 TLS 進行資料保護之前，請勿輸入敏感資訊。",
  "secAlertConf": "某些設定易受攻擊。建議加強安全協議以防止潛在漏洞。",
  "secAlertSSL": "面板缺少安全連線。請安裝 TLS 證書以保護資料安全。",
  "secAlertPanelPort": "面板預設埠存在安全風險。請配置隨機埠或特定埠。",
  "secAlertPanelURI": "面板預設 URI 路徑不安全。請配置複雜的 URI 路徑。",
  "secAlertSubURI": "訂閱預設 URI 路徑不安全。請配置複雜的 URI 路徑。",
  "secAlertSubJsonURI": "訂閱 JSON 預設 URI 路徑不安全。請配置複雜的 URI 路徑。",
  "emptyDnsDesc": "未添加DNS伺服器。",
  "emptyFakeDnsDesc": "未添加Fake DNS伺服器。",
  "emptyBalancersDesc": "未添加負載平衡器。",
  "emptyReverseDesc": "未添加反向代理。",
  "somethingWentWrong": "發生錯誤",
  "subscription": {
    "title": "訂閱資訊",
    "subId": "訂閱 ID",
    "status": "狀態",
    "downloaded": "已下載",
    "uploaded": "已上傳",
    "expiry": "到期",
    "totalQuota": "總配額",
    "individualLinks": "個別連結",
    "active": "啟用",
    "inactive": "停用",
    "unlimited": "無限制",
    "noExpiry": "無到期"
  },
  "menu": {
    "theme": "主題",
    "dark": "深色",
    "ultraDark": "超深色",
    "dashboard": "系統狀態",
    "inbounds": "入站",
    "clients": "客戶端",
    "groups": "群組",
    "nodes": "節點",
    "settings": "面板設定",
    "xray": "Xray 設定",
    "apiDocs": "API 文件",
    "logout": "退出登入",
    "link": "管理",
    "donate": "捐贈"
  },
  "pages": {
    "login": {
      "hello": "你好",
      "title": "歡迎",
      "loginAgain": "登入時效已過，請重新登入",
      "toasts": {
        "invalidFormData": "資料格式錯誤",
        "emptyUsername": "請輸入使用者名稱",
        "emptyPassword": "請輸入密碼",
        "wrongUsernameOrPassword": "用戶名、密碼或雙重驗證碼無效。",
        "successLogin": "您已成功登入您的帳戶。"
      }
    },
    "index": {
      "title": "系統狀態",
      "cpu": "CPU",
      "logicalProcessors": "邏輯處理器",
      "frequency": "頻率",
      "swap": "Swap",
      "storage": "儲存",
      "memory": "RAM",
      "threads": "執行緒",
      "xrayStatus": "Xray",
      "stopXray": "停止",
      "restartXray": "重新啟動",
      "xraySwitch": "版本",
      "xrayUpdates": "Xray 更新",
      "xraySwitchClick": "選擇你要切換到的版本",
      "xraySwitchClickDesk": "請謹慎選擇，因為較舊版本可能與當前配置不相容",
      "updatePanel": "更新面板",
      "panelUpdateDesc": "這將把 3X-UI 更新到最新版本並重新啟動面板服務。",
      "currentPanelVersion": "目前面板版本",
      "latestPanelVersion": "最新面板版本",
      "panelUpToDate": "面板已是最新",
      "upToDate": "已是最新",
      "xrayStatusUnknown": "未知",
      "xrayStatusRunning": "運行中",
      "xrayStatusStop": "停止",
      "xrayStatusError": "錯誤",
      "xrayErrorPopoverTitle": "執行Xray時發生錯誤",
      "operationHours": "系統正常執行時間",
      "systemHistoryTitle": "系統歷史",
      "charts": "圖表",
      "xrayMetricsTitle": "Xray 指標",
      "xrayMetricsDisabled": "未設定 Xray 指標端點",
      "xrayMetricsHint": "在 xray 設定中加入頂層 metrics 區塊,tag 為 metrics_out,listen 為 127.0.0.1:11111,然後重啟 xray。",
      "xrayObservatoryEmpty": "尚無 Observatory 資料",
      "xrayObservatoryHint": "在 xray 設定中加入 observatory 區塊,列出要探測的出站 tag,然後重啟 xray。",
      "xrayObservatoryTagPlaceholder": "選擇出站",
      "xrayObservatoryAlive": "在線",
      "xrayObservatoryDead": "離線",
      "xrayObservatoryLastSeen": "最後在線",
      "xrayObservatoryLastTry": "最後嘗試",
      "trendLast2Min": "最近 2 分鐘",
      "systemLoad": "系統負載",
      "systemLoadDesc": "過去 1、5 和 15 分鐘的系統平均負載",
      "connectionCount": "連線數",
      "ipAddresses": "IP地址",
      "toggleIpVisibility": "切換IP可見性",
      "overallSpeed": "整體速度",
      "upload": "上傳",
      "download": "下載",
      "totalData": "總數據",
      "sent": "已發送",
      "received": "已接收",
      "documentation": "文件",
      "xraySwitchVersionDialog": "您確定要變更Xray版本嗎？",
      "xraySwitchVersionDialogDesc": "這將會把Xray版本變更為#version#。",
      "xraySwitchVersionPopover": "Xray 更新成功",
      "panelUpdateDialog": "您確定要更新面板嗎？",
      "panelUpdateDialogDesc": "這將把 3X-UI 更新到 #version# 並重新啟動面板服務。",
      "panelUpdateCheckPopover": "面板更新檢查失敗",
      "panelUpdateStartedPopover": "面板更新已開始",
      "geofileUpdateDialog": "您確定要更新地理檔案嗎？",
      "geofileUpdateDialogDesc": "這將更新 #filename# 檔案。",
      "geofilesUpdateDialogDesc": "這將更新所有文件。",
      "geofilesUpdateAll": "全部更新",
      "geofileUpdatePopover": "地理檔案更新成功",
      "customGeoTitle": "自訂 GeoSite / GeoIP",
      "customGeoAdd": "新增",
      "customGeoType": "類型",
      "customGeoAlias": "別名",
      "customGeoUrl": "URL",
      "customGeoEnabled": "啟用",
      "customGeoLastUpdated": "上次更新",
      "customGeoExtColumn": "路由 (ext:…)",
      "customGeoToastUpdateAll": "所有自訂來源已更新",
      "customGeoActions": "操作",
      "customGeoEdit": "編輯",
      "customGeoDelete": "刪除",
      "customGeoDownload": "立即更新",
      "customGeoModalAdd": "新增自訂 geo",
      "customGeoModalEdit": "編輯自訂 geo",
      "customGeoModalSave": "儲存",
      "customGeoDeleteConfirm": "刪除此自訂 geo 來源？",
      "customGeoRoutingHint": "在路由規則中將值欄寫為 ext:檔案.dat:標籤（替換標籤）。",
      "customGeoInvalidId": "無效的資源 ID",
      "customGeoAliasesError": "載入自訂 geo 別名失敗",
      "customGeoValidationAlias": "別名只能包含小寫字母、數字、- 和 _",
      "customGeoValidationUrl": "URL 必須以 http:// 或 https:// 開頭",
      "customGeoAliasPlaceholder": "a-z 0-9 _ -",
      "customGeoAliasLabelSuffix": "（自訂）",
      "customGeoToastList": "自訂 geo 清單",
      "customGeoToastAdd": "新增自訂 geo",
      "customGeoToastUpdate": "更新自訂 geo",
      "customGeoToastDelete": "自訂 geofile「{{ .fileName }}」已刪除",
      "customGeoToastDownload": "geofile「{{ .fileName }}」已更新",
      "customGeoErrInvalidType": "類型必須是 geosite 或 geoip",
      "customGeoErrAliasRequired": "請填寫別名",
      "customGeoErrAliasPattern": "別名包含不允許的字元",
      "customGeoErrAliasReserved": "此別名已保留",
      "customGeoErrUrlRequired": "請填寫 URL",
      "customGeoErrInvalidUrl": "URL 無效",
      "customGeoErrUrlScheme": "URL 必須使用 http 或 https",
      "customGeoErrUrlHost": "URL 主機無效",
      "customGeoErrDuplicateAlias": "此類型已使用該別名",
      "customGeoErrNotFound": "找不到自訂 geo 來源",
      "customGeoErrDownload": "下載失敗",
      "customGeoErrUpdateAllIncomplete": "有一個或多個自訂 geo 來源更新失敗",
      "customGeoEmpty": "尚無自訂 geo 來源 — 點擊「新增」以建立",
      "dontRefresh": "安裝中，請勿重新整理此頁面",
      "logs": "記錄",
      "config": "配置",
      "backup": "備份",
      "backupTitle": "備份和恢復",
      "exportDatabase": "備份",
      "exportDatabaseDesc": "點擊下載包含當前資料庫備份的 .db 文件到您的設備。",
      "importDatabase": "恢復",
      "importDatabaseDesc": "點擊選擇並上傳設備中的 .db 文件以從備份恢復資料庫。",
      "importDatabaseSuccess": "資料庫匯入成功",
      "importDatabaseError": "匯入資料庫時發生錯誤",
      "readDatabaseError": "讀取資料庫時發生錯誤",
      "getDatabaseError": "檢索資料庫時發生錯誤",
      "getConfigError": "檢索設定檔時發生錯誤"
    },
    "inbounds": {
      "title": "入站",
      "totalDownUp": "總上傳 / 下載",
      "totalUsage": "總用量",
      "inboundCount": "入站數量",
      "operate": "選單",
      "enable": "啟用",
      "remark": "備註",
      "node": "節點",
      "deployTo": "部署到",
      "localPanel": "本機面板",
      "fallbacks": {
        "title": "Fallbacks",
        "help": "當此入站的連線未匹配任何用戶時，將其路由到另一個入站。在下方選擇一個子入站，路由欄位（SNI / ALPN / Path / xver）會自動從子入站的傳輸方式填入——大多數情境不需要再調整。每個子入站應監聽 127.0.0.1，security=none。",
        "empty": "尚未新增回落",
        "add": "新增回落",
        "pickInbound": "選擇一個入站",
        "matchAny": "任何",
        "destPlaceholder": "自動（子入站 listen:port）",
        "rederive": "從子入站重新填入",
        "rederived": "已從子入站重新填入",
        "editAdvanced": "編輯路由欄位",
        "hideAdvanced": "隱藏進階",
        "quickAddAll": "一鍵新增所有符合的入站",
        "quickAdded": "已新增 {n} 個回落",
        "quickAddedNone": "沒有可新增的新入站",
        "routesWhen": "當條件成立時路由",
        "defaultCatchAll": "預設 — 兜底匹配其餘"
      },
      "protocol": "協議",
      "port": "連接埠",
      "portMap": "連接埠對應",
      "traffic": "流量",
      "details": "詳細資訊",
      "transportConfig": "傳輸",
      "expireDate": "到期時間",
      "createdAt": "建立時間",
      "updatedAt": "更新時間",
      "resetTraffic": "重置流量",
      "addInbound": "新增入站",
      "generalActions": "通用操作",
      "modifyInbound": "修改入站",
      "deleteInbound": "刪除入站",
      "deleteInboundContent": "確定要刪除入站嗎？",
      "deleteConfirmTitle": "刪除入站「{remark}」？",
      "deleteConfirmContent": "將刪除此入站及其所有客戶端。此操作無法復原。",
      "resetConfirmTitle": "重置「{remark}」的流量？",
      "resetConfirmContent": "將此入站的上/下行計數器歸零。",
      "cloneConfirmTitle": "複製入站「{remark}」？",
      "cloneConfirmContent": "使用新連接埠和空客戶端清單建立副本。",
      "delAllClients": "刪除所有客戶端",
      "delAllClientsConfirmTitle": "從「{remark}」中刪除全部 {count} 個客戶端？",
      "delAllClientsConfirmContent": "從此入站中移除每個客戶端並捨棄其流量記錄。入站本身將保留。此操作無法復原。",
      "attachClients": "附加客戶端到…",
      "addClientsToGroup": "將客戶端加入群組…",
      "attachClientsTitle": "從「{remark}」附加客戶端",
      "attachClientsDesc": "將相同的 {count} 個客戶端(相同 UUID/密碼與共享流量)附加到選定入站。它們仍保留於此入站。",
      "attachClientsTargets": "目標入站",
      "attachClientsNoTargets": "沒有可附加的其他相容入站。",
      "attachClientsResult": "已附加 {attached},已略過 {skipped}。",
      "attachClientsResultMixed": "已附加 {attached},已略過 {skipped},錯誤 {errors}。",
      "attachClientsSelectLabel": "要附加的客戶端",
      "attachClientsSearchPlaceholder": "搜尋電子郵件或備註",
      "attachClientsStatusDisabled": "已停用",
      "attachClientsSelectedCount": "已選 {selected}/{total}",
      "detachClients": "分離客戶端",
      "detachClientsTitle": "從「{remark}」分離客戶端",
      "detachClientsDesc": "僅從此入站移除選取的客戶端。客戶端記錄保留(用 Delete 完全移除)。來源共有 {count} 個客戶端。",
      "detachClientsResult": "已分離 {detached},已略過 {skipped}。",
      "detachClientsResultMixed": "已分離 {detached},已略過 {skipped},錯誤 {errors}。",
      "detachClientsSelectLabel": "要分離的客戶端",
      "exportLinksTitle": "匯出入站連結",
      "exportSubsTitle": "匯出訂閱連結",
      "exportAllLinksTitle": "匯出所有入站連結",
      "exportAllSubsTitle": "匯出所有訂閱連結",
      "exportAllLinksFileName": "所有入站",
      "exportAllSubsFileName": "所有入站-Subs",
      "inboundJsonTitle": "入站 JSON",
      "deleteClient": "刪除客戶端",
      "deleteClientContent": "確定要刪除客戶端嗎？",
      "resetTrafficContent": "確定要重置流量嗎？",
      "copyLink": "複製連結",
      "address": "地址",
      "network": "網路",
      "destinationPort": "目標埠",
      "targetAddress": "目標地址",
      "monitorDesc": "留空表示監聽所有 IP",
      "meansNoLimit": "= 無限制。(單位: GB)",
      "totalFlow": "總流量",
      "leaveBlankToNeverExpire": "留空表示永不過期",
      "noRecommendKeepDefault": "建議保留預設值",
      "certificatePath": "檔案路徑",
      "certificateContent": "檔案內容",
      "publicKey": "公鑰",
      "privatekey": "私鑰",
      "clickOnQRcode": "點選二維碼複製",
      "client": "客戶",
      "export": "匯出連結",
      "clone": "複製",
      "cloneInbound": "複製",
      "cloneInboundContent": "此入站規則除埠（Port）、監聽 IP（Listening IP）和客戶端（Clients）以外的所有配置都將應用於克隆",
      "cloneInboundOk": "建立克隆",
      "resetAllTraffic": "重置所有入站流量",
      "resetAllTrafficTitle": "重置所有入站流量",
      "resetAllTrafficContent": "確定要重置所有入站流量嗎？",
      "resetInboundClientTraffics": "重置客戶端流量",
      "resetInboundClientTrafficTitle": "重置所有客戶端流量",
      "resetInboundClientTrafficContent": "確定要重置此入站客戶端的所有流量嗎？",
      "resetAllClientTraffics": "重置所有客戶端流量",
      "resetAllClientTrafficTitle": "重置所有客戶端流量",
      "resetAllClientTrafficContent": "確定要重置所有客戶端的所有流量嗎？",
      "delDepletedClients": "刪除流量耗盡的客戶端",
      "delDepletedClientsTitle": "刪除流量耗盡的客戶端",
      "delDepletedClientsContent": "確定要刪除所有流量耗盡的客戶端嗎？",
      "email": "電子郵件",
      "emailDesc": "電子郵件必須完全唯一",
      "IPLimit": "IP 限制",
      "IPLimitDesc": "如果數量超過設定值，則禁用入站流量。（0 = 禁用）",
      "IPLimitlog": "IP 日誌",
      "IPLimitlogDesc": "IP 歷史日誌（要啟用被禁用的入站流量，請清除日誌）",
      "IPLimitlogclear": "清除日誌",
      "setDefaultCert": "從面板設定證書",
      "setDefaultCertEmpty": "面板尚未設定憑證。請先在「設定」中設定。",
      "streamTab": "傳輸",
      "securityTab": "安全",
      "sniffingTab": "嗅探",
      "sniffingMetadataOnly": "僅中繼資料",
      "sniffingRouteOnly": "僅路由",
      "sniffingIpsExcluded": "排除的 IP",
      "sniffingDomainsExcluded": "排除的網域",
      "decryption": "解密",
      "encryption": "加密",
      "vlessAuthX25519": "X25519 認證",
      "vlessAuthMlkem768": "ML-KEM-768 認證",
      "vlessAuthCustom": "自訂",
      "vlessAuthSelected": "已選擇：{auth}",
      "advanced": {
        "title": "入站 JSON 部分",
        "subtitle": "完整入站 JSON 以及針對 settings、sniffing 和 streamSettings 的專用編輯器。",
        "all": "全部",
        "allHelp": "在單一編輯器中編輯包含所有欄位的完整入站物件。",
        "settings": "設定",
        "settingsHelp": "Xray settings 區塊包裝：",
        "sniffing": "Sniffing",
        "sniffingHelp": "Xray sniffing 區塊包裝：",
        "stream": "Stream",
        "streamHelp": "Xray stream 區塊包裝：",
        "jsonErrorPrefix": "進階 JSON"
      },
      "telegramDesc": "請提供Telegram聊天ID。（在機器人中使用'/id'命令）或（{'@'}userinfobot",
      "subscriptionDesc": "要找到你的訂閱 URL，請導航到“詳細資訊”。此外，你可以為多個客戶端使用相同的名稱。",
      "same": "相同",
      "inboundData": "入站資料",
      "exportInbound": "匯出入站規則",
      "import": "匯入",
      "importInbound": "匯入入站規則",
      "periodicTrafficResetTitle": "流量重置",
      "periodicTrafficResetDesc": "按指定間隔自動重置流量計數器",
      "lastReset": "上次重置",
      "periodicTrafficReset": {
        "never": "從不",
        "daily": "每日",
        "weekly": "每週",
        "monthly": "每月",
        "hourly": "每小時"
      },
      "toasts": {
        "obtain": "獲取",
        "updateSuccess": "更新成功",
        "logCleanSuccess": "日誌已清除",
        "inboundsUpdateSuccess": "入站連接已成功更新",
        "inboundUpdateSuccess": "入站連接已成功更新",
        "inboundCreateSuccess": "入站連接已成功建立",
        "inboundDeleteSuccess": "入站連接已成功刪除",
        "inboundClientAddSuccess": "已新增入站客戶端",
        "inboundClientDeleteSuccess": "入站客戶端已刪除",
        "inboundClientUpdateSuccess": "入站客戶端已更新",
        "delDepletedClientsSuccess": "所有耗盡客戶端已刪除",
        "resetAllClientTrafficSuccess": "客戶端所有流量已重置",
        "resetAllTrafficSuccess": "所有流量已重置",
        "resetInboundClientTrafficSuccess": "流量已重置",
        "resetInboundTrafficSuccess": "入站流量已重置",
        "trafficGetError": "取得流量資料時發生錯誤",
        "getNewX25519CertError": "取得X25519憑證時發生錯誤。",
        "getNewmldsa65Error": "取得mldsa65憑證時發生錯誤。",
        "getNewVlessEncError": "取得VlessEnc憑證時發生錯誤。"
      },
      "form": {
        "moveUp": "上移",
        "moveDown": "下移",
        "addAll": "全部新增",
        "addAllFallbackTooltip": "為每個尚未連線的符合條件入站新增一個 fallback 列",
        "peers": "Peers",
        "addPeer": "新增 peer",
        "keepAlive": "Keep-alive",
        "autoSystemRoutesTooltip": "僅 Windows。CIDR 會自動加入系統路由表,使匹配的流量通過 TUN。",
        "autoOutboundsInterface": "自動出站介面",
        "autoOutboundsInterfaceTooltip": "出站流量的實體介面。使用 'auto' 進行偵測;設定 Auto system routes 時自動啟用。",
        "rewriteAddress": "改寫地址",
        "rewritePort": "改寫連接埠",
        "allowedNetwork": "允許的網路",
        "followRedirect": "跟隨重新導向",
        "accounts": "帳號",
        "allowTransparent": "允許透明",
        "encryptionMethod": "加密方法",
        "visionTestseed": "Vision testseed",
        "version": "版本",
        "udpIdleTimeout": "UDP 閒置逾時 (s)",
        "masquerade": "偽裝",
        "type": "類型",
        "upstreamUrl": "Upstream URL",
        "rewriteHost": "改寫 Host",
        "skipTlsVerify": "略過 TLS 驗證",
        "directory": "目錄",
        "statusCode": "狀態碼",
        "body": "Body",
        "headers": "標頭",
        "proxyProtocol": "Proxy Protocol",
        "requestVersion": "請求版本",
        "requestMethod": "請求方法",
        "requestPath": "請求路徑",
        "requestHeaders": "請求標頭",
        "responseVersion": "回應版本",
        "responseStatus": "回應狀態",
        "responseReason": "回應原因",
        "responseHeaders": "回應標頭",
        "heartbeatPeriod": "心跳週期",
        "serviceName": "服務名稱",
        "authority": "Authority",
        "multiMode": "多模式",
        "maxBufferedUpload": "最大緩衝上傳",
        "maxUploadSize": "最大上傳大小 (位元組)",
        "streamUpServer": "Stream-Up 伺服器",
        "serverMaxHeaderBytes": "伺服器最大標頭位元組",
        "paddingBytes": "Padding 位元組",
        "uplinkHttpMethod": "Uplink HTTP 方法",
        "paddingObfsMode": "Padding 混淆模式",
        "paddingKey": "Padding Key",
        "paddingHeader": "Padding Header",
        "paddingPlacement": "Padding 位置",
        "paddingMethod": "Padding 方法",
        "sessionPlacement": "Session 位置",
        "sessionKey": "Session Key",
        "sequencePlacement": "Sequence 位置",
        "sequenceKey": "Sequence Key",
        "uplinkDataPlacement": "Uplink 資料位置",
        "uplinkDataKey": "Uplink 資料 Key",
        "noSseHeader": "無 SSE 標頭",
        "ttiMs": "TTI (ms)",
        "uplinkMbps": "上行 (MB/s)",
        "downlinkMbps": "下行 (MB/s)",
        "cwndMultiplier": "CWND 倍數",
        "maxSendingWindow": "最大發送視窗",
        "externalProxy": "外部代理",
        "sniPlaceholder": "SNI (預設為 host)",
        "fingerprint": "指紋",
        "defaultOption": "預設",
        "routeMark": "Route Mark",
        "tcpKeepAliveInterval": "TCP Keep Alive 間隔",
        "tcpKeepAliveIdle": "TCP Keep Alive Idle",
        "tcpMaxSeg": "TCP Max Seg",
        "tcpUserTimeout": "TCP User Timeout",
        "tcpWindowClamp": "TCP Window Clamp",
        "tcpFastOpen": "TCP Fast Open",
        "multipathTcp": "Multipath TCP",
        "penetrate": "Penetrate",
        "v6Only": "僅 V6",
        "tcpCongestion": "TCP Congestion",
        "dialerProxy": "Dialer Proxy",
        "trustedXForwardedFor": "信任的 X-Forwarded-For",
        "addressPortStrategy": "地址+連接埠策略",
        "tryDelayMs": "嘗試延遲 (ms)",
        "prioritizeIPv6": "IPv6 優先",
        "interleave": "Interleave",
        "maxConcurrentTry": "最大並發嘗試",
        "customSockopt": "自訂 sockopt",
        "addCustomOption": "新增自訂選項",
        "serverNameIndication": "SNI",
        "cipherSuites": "Cipher Suites",
        "autoOption": "自動",
        "minMaxVersion": "最小/最大版本",
        "rejectUnknownSni": "拒絕未知 SNI",
        "disableSystemRoot": "停用系統根",
        "sessionResumption": "工作階段恢復",
        "oneTimeLoading": "一次性載入",
        "usageOption": "使用選項",
        "buildChain": "建立憑證鏈",
        "echKey": "ECH key",
        "echConfig": "ECH 設定",
        "pinnedPeerCertSha256": "釘選對端憑證 SHA-256",
        "pinnedPeerCertSha256Tip": "對端憑證的 Base64 編碼 SHA-256 雜湊。僅面板使用 — 不寫入伺服器的 xray 設定，但會包含在分享連結中，以便用戶端釘選憑證。",
        "pinnedPeerCertSha256Placeholder": "base64 雜湊，以逗號分隔",
        "generateRandomPin": "產生隨機雜湊",
        "getNewEchCert": "取得新 ECH 憑證",
        "show": "顯示",
        "xver": "Xver",
        "target": "目標",
        "maxTimeDiff": "最大時間差 (ms)",
        "minClientVer": "最小客戶端版本",
        "maxClientVer": "最大客戶端版本",
        "shortIds": "Short IDs",
        "spiderX": "SpiderX",
        "getNewCert": "取得新憑證",
        "mldsa65Seed": "mldsa65 Seed",
        "mldsa65Verify": "mldsa65 Verify",
        "getNewSeed": "取得新 Seed"
      },
      "info": {
        "mode": "模式",
        "grpcServiceName": "grpc serviceName",
        "grpcMultiMode": "grpc multiMode",
        "interfaceName": "介面名稱",
        "mtu": "MTU",
        "gateway": "Gateway",
        "dns": "DNS",
        "outboundsInterface": "出站介面",
        "autoSystemRoutes": "自動系統路由",
        "followRedirect": "FollowRedirect",
        "auth": "認證",
        "noKernelTun": "非核心 TUN",
        "keepAlive": "Keep alive",
        "peerNumber": "Peer {n}",
        "peerNumberConfig": "Peer {n} 設定"
      },
      "stream": {
        "general": {
          "request": "請求",
          "response": "響應",
          "name": "名稱",
          "value": "值"
        },
        "tcp": {
          "version": "版本",
          "method": "方法",
          "path": "路徑",
          "status": "狀態",
          "statusDescription": "狀態說明",
          "requestHeader": "請求頭",
          "responseHeader": "響應頭"
        }
      }
    },
    "clients": {
      "add": "新增客戶端",
      "edit": "編輯客戶端",
      "submitAdd": "新增客戶端",
      "submitEdit": "儲存變更",
      "clientCount": "客戶端數量",
      "bulk": "批次新增",
      "copyFromInbound": "從入站複製客戶端",
      "copyToInbound": "複製客戶端至",
      "copySelected": "複製所選",
      "copySource": "來源",
      "copyEmailPreview": "產生的信箱預覽",
      "copySelectSourceFirst": "請先選擇一個來源入站。",
      "copyResult": "複製結果",
      "copyResultSuccess": "複製成功",
      "copyResultNone": "沒有內容可複製：未選取客戶端或來源為空",
      "copyResultErrors": "複製錯誤",
      "copyFlowLabel": "新客戶端的 Flow (VLESS)",
      "copyFlowHint": "套用至所有被複製的客戶端。留空則略過。",
      "selectAll": "全選",
      "clearAll": "全部清除",
      "method": "方法",
      "first": "首個",
      "last": "末位",
      "ipLog": "IP 日誌",
      "prefix": "前綴",
      "postfix": "後綴",
      "delayedStart": "首次使用後開始",
      "expireDays": "時長",
      "days": "天",
      "renew": "自動續期",
      "renewDesc": "到期後自動續期。(0 = 停用) (單位: 天)",
      "searchPlaceholder": "搜尋電子郵件、備註、sub ID、UUID、密碼、auth…",
      "filterTitle": "篩選客戶端",
      "clearAllFilters": "清除全部",
      "sortOldest": "最舊優先",
      "sortNewest": "最新優先",
      "sortRecentlyUpdated": "最近更新",
      "sortRecentlyOnline": "最近上線",
      "sortEmailAZ": "電子郵件 A→Z",
      "sortEmailZA": "電子郵件 Z→A",
      "sortMostTraffic": "流量最多",
      "sortHighestRemaining": "剩餘最多",
      "sortExpiringSoonest": "即將到期",
      "has": "擁有",
      "hasNot": "不擁有",
      "title": "客戶端",
      "actions": "操作",
      "totalGB": "總上傳/下載 (GB)",
      "expiryTime": "到期時間",
      "addClients": "新增客戶端",
      "limitIp": "IP 限制",
      "password": "密碼",
      "subId": "訂閱 ID",
      "online": "上線",
      "email": "電子郵件",
      "group": "群組",
      "groupDesc": "用於將相關客戶端歸類的邏輯標籤(如團隊、客戶、地區)。可從工具列篩選。",
      "groupPlaceholder": "如 customer-a",
      "comment": "備註",
      "traffic": "流量",
      "offline": "離線",
      "addTitle": "新增客戶端",
      "qrCode": "QR 碼",
      "moreInformation": "更多資訊",
      "delete": "刪除",
      "reset": "重設流量",
      "editTitle": "編輯客戶端",
      "client": "客戶端",
      "enabled": "已啟用",
      "remaining": "剩餘",
      "duration": "時長",
      "attachedInbounds": "關聯入站",
      "selectInbound": "選擇一個或多個入站",
      "noSubId": "此客戶端沒有 subId，無法產生共享連結。",
      "noLinks": "沒有可共享的連結 — 請先將此客戶端關聯至支援協定的入站。",
      "link": "連結",
      "resetNotPossible": "請先將此客戶端關聯至入站。",
      "general": "一般",
      "resetAllTraffics": "重設所有客戶端流量",
      "resetAllTrafficsTitle": "重設所有客戶端流量？",
      "resetAllTrafficsContent": "所有客戶端的上下行計數器將歸零。配額與到期時間不受影響。此操作無法復原。",
      "deleteConfirmTitle": "刪除客戶端 {email}？",
      "deleteConfirmContent": "將從所有關聯入站中移除該客戶端並刪除其流量紀錄。此操作無法復原。",
      "deleteSelected": "刪除 ({count})",
      "adjustSelected": "調整 ({count})",
      "subLinksSelected": "訂閱連結 ({count})",
      "addToGroupTitle": "將 {count} 個客戶端加入群組",
      "addToGroupTooltip": "選擇現有群組或輸入新名稱。使用 Ungroup 操作從當前群組移除客戶端。",
      "addToGroupPlaceholder": "群組名稱",
      "addToGroupSuccessToast": "已將 {count} 個客戶端加入 {group}",
      "ungroupSuccessToast": "已清除 {count} 個客戶端的群組",
      "ungroup": "取消群組",
      "ungroupConfirmTitle": "將 {count} 個客戶端從其群組中移除?",
      "ungroupConfirmContent": "清除每個選取客戶端的群組標籤。客戶端本身保留(用 Delete 完全移除)。",
      "addToGroup": "加入群組",
      "attach": "附加",
      "adjust": "調整",
      "subLinks": "訂閱連結",
      "selectedCount": "已選 {count} 項",
      "attachSelected": "附加 ({count})",
      "attachToInboundsTitle": "將 {count} 個客戶端附加到入站",
      "attachToInboundsDesc": "將選取的 {count} 個客戶端(相同 UUID/密碼與共享流量)附加到選定入站。它們保留現有附加關係。",
      "attachToInboundsTargets": "目標入站",
      "attachToInboundsNoTargets": "沒有可供附加的多用戶入站。",
      "detachSelected": "分離 ({count})",
      "detach": "分離",
      "detachFromInboundsTitle": "從入站分離 {count} 個客戶端",
      "detachFromInboundsDesc": "從選定入站中移除選取的 {count} 個客戶端。客戶端未附加的配對會被靜默略過。客戶端記錄保留(用 Delete 完全移除)。",
      "detachFromInboundsTargets": "要分離的入站",
      "detachFromInboundsNoTargets": "沒有可用的多用戶入站。",
      "detachFromInboundsResult": "已分離 {detached},已略過 {skipped}。",
      "detachFromInboundsResultMixed": "已分離 {detached},已略過 {skipped},錯誤 {errors}。",
      "subLinksTitle": "訂閱連結 ({count})",
      "subLinkColumn": "訂閱 URL",
      "subJsonLinkColumn": "訂閱 JSON URL",
      "subLinksCopyAll": "全部複製",
      "subLinksCopiedAll": "已複製 {count} 條連結",
      "subLinksEmpty": "選取的客戶端皆無訂閱 ID。",
      "subLinksDisabled": "訂閱服務已停用。",
      "subLinksDisabledHint": "在面板設定 → 訂閱中啟用訂閱以產生連結。",
      "bulkDeleteConfirmTitle": "刪除 {count} 個客戶端？",
      "bulkDeleteConfirmContent": "每個所選客戶端都會從關聯的入站中被移除，其流量紀錄也會被刪除。此操作無法復原。",
      "bulkAdjustTitle": "調整 {count} 個客戶端",
      "bulkAdjustHint": "正值延長，負值減少。具有無限期限或流量的客戶端將跳過該欄位。",
      "bulkAdjustNothing": "套用前請設定天數或流量。",
      "addDays": "新增天數",
      "addTrafficGB": "新增流量 (GB)",
      "delDepleted": "刪除已耗盡",
      "delDepletedConfirmTitle": "刪除已耗盡的客戶端？",
      "delDepletedConfirmContent": "刪除所有流量配額已用盡或已過期的客戶端。此操作無法復原。",
      "auth": "認證",
      "hysteriaAuth": "Hysteria 認證",
      "uuid": "UUID",
      "flow": "Flow",
      "vmessSecurity": "VMess 加密",
      "reverseTag": "反向標籤",
      "reverseTagPlaceholder": "選用 Reverse tag",
      "telegramId": "Telegram 使用者 ID",
      "telegramIdPlaceholder": "數字形式的 Telegram 使用者 ID (0 = 無)",
      "created": "建立時間",
      "updated": "更新時間",
      "ipLimit": "IP 限制",
      "toasts": {
        "deleted": "客戶端已刪除",
        "trafficReset": "流量已重設",
        "allTrafficsReset": "所有客戶端流量已重設",
        "bulkDeleted": "已刪除 {count} 個客戶端",
        "bulkDeletedMixed": "已刪除 {ok} 個，失敗 {failed} 個",
        "bulkCreated": "已建立 {count} 個客戶端",
        "bulkCreatedMixed": "已建立 {ok} 個，失敗 {failed} 個",
        "bulkAdjusted": "已調整 {count} 個客戶端",
        "bulkAdjustedMixed": "已調整 {ok} 個，跳過 {skipped} 個",
        "delDepleted": "已刪除 {count} 個已耗盡的客戶端"
      }
    },
    "groups": {
      "title": "群組",
      "name": "名稱",
      "clientCount": "群組中的客戶端",
      "totalGroups": "群組總數",
      "totalGroupedClients": "有群組的客戶端",
      "emptyGroups": "空群組",
      "addGroup": "新增群組",
      "createSuccess": "已建立群組「{name}」。",
      "rename": "重新命名",
      "renameTitle": "重新命名 {name}",
      "renameCollision": "已存在名為「{name}」的群組。",
      "renameSuccess": "已為 {count} 個客戶端重新命名群組。",
      "deleteConfirmTitle": "刪除群組 {name}?",
      "deleteConfirmContent": "這將刪除群組並清除 {count} 個客戶端的標籤。客戶端本身不會被刪除。",
      "deleteSuccess": "已清除 {count} 個客戶端的群組。",
      "resetTraffic": "重置流量",
      "resetConfirmTitle": "重置群組 {name} 的流量?",
      "resetConfirmContent": "這將將此群組中所有 {count} 個客戶端的上行/下行流量歸零。",
      "resetSuccess": "已重置 {count} 個客戶端的流量。",
      "adjustSuccess": "已調整 {name} 中的 {count} 個客戶端。",
      "emptyForAction": "此群組尚無客戶端。",
      "deleteGroupOnly": "刪除群組(保留客戶端)",
      "deleteClients": "刪除群組中的客戶端",
      "deleteClientsConfirmTitle": "刪除 {name} 中的所有客戶端?",
      "deleteClientsConfirmContent": "這將永久刪除 {count} 個客戶端及其流量記錄。群組標籤亦會被清除。此操作無法復原。",
      "deleteClientsSuccess": "已刪除 {count} 個客戶端。",
      "deleteClientsMixed": "已刪除 {ok},已略過 {failed}",
      "addToGroup": "新增客戶端…",
      "addToGroupTitle": "將客戶端加入群組「{name}」",
      "addToGroupDesc": "選擇要加入此群組的客戶端。保留其現有入站附加;僅更改群組標籤。已在此群組中的客戶端不會列出。",
      "addToGroupEmpty": "沒有其他可加入的客戶端。",
      "addToGroupResult": "已將 {count} 個客戶端加入 {name}。",
      "removeFromGroup": "移除客戶端…",
      "removeFromGroupTitle": "從群組「{name}」移除客戶端",
      "removeFromGroupDesc": "選擇要從此群組移除的成員。客戶端本身保留(用「刪除群組中的客戶端」完全移除)。",
      "removeFromGroupResult": "已從 {name} 移除 {count} 個客戶端。"
    },
    "nodes": {
      "title": "節點",
      "addNode": "新增節點",
      "editNode": "編輯節點",
      "totalNodes": "節點總數",
      "onlineNodes": "上線",
      "offlineNodes": "離線",
      "avgLatency": "平均延遲",
      "name": "名稱",
      "namePlaceholder": "例如：de-frankfurt-1",
      "addressPlaceholder": "panel.example.com 或 1.2.3.4",
      "remark": "備註",
      "scheme": "協議",
      "address": "位址",
      "port": "連接埠",
      "basePath": "Base Path",
      "apiToken": "API Token",
      "apiTokenPlaceholder": "遠端面板設定頁中的權杖",
      "apiTokenHint": "遠端面板在 設定 → API 權杖 中顯示其 API 權杖。",
      "regenerate": "重新產生權杖",
      "regenerateConfirm": "重新產生會使目前的權杖失效。任何使用該權杖的中央面板將失去存取權，直到更新為止。是否繼續？",
      "allowPrivateAddress": "允許私有地址",
      "allowPrivateAddressHint": "僅對私有網路或VPN上的節點啟用。",
      "enable": "已啟用",
      "status": "狀態",
      "cpu": "CPU",
      "mem": "記憶體",
      "uptime": "運行時間",
      "latency": "延遲",
      "lastHeartbeat": "上次心跳",
      "xrayVersion": "Xray 版本",
      "panelVersion": "面板版本",
      "actions": "操作",
      "probe": "立即探測",
      "testConnection": "測試連線",
      "connectionOk": "連線正常 ({ms} ms)",
      "connectionFailed": "連線失敗",
      "never": "從未",
      "justNow": "剛剛",
      "deleteConfirmTitle": "刪除節點「{name}」？",
      "deleteConfirmContent": "這將停止監控該節點。遠端面板本身不受影響。",
      "statusValues": {
        "online": "上線",
        "offline": "離線",
        "unknown": "未知"
      },
      "toasts": {
        "list": "載入節點失敗",
        "obtain": "載入節點失敗",
        "add": "新增節點",
        "update": "更新節點",
        "delete": "刪除節點",
        "deleted": "節點已刪除",
        "test": "測試連線",
        "fillRequired": "名稱、位址、埠與 API 權杖為必填",
        "probeFailed": "探測失敗"
      }
    },
    "settings": {
      "title": "面板設定",
      "save": "儲存",
      "infoDesc": "此處的所有更改都需要儲存並重啟面板才能生效",
      "restartPanel": "重新啟動面板",
      "restartPanelDesc": "確定要重啟面板嗎？若重啟後無法訪問面板，請前往伺服器檢視面板日誌資訊",
      "restartPanelSuccess": "面板已成功重新啟動",
      "actions": "操作",
      "resetDefaultConfig": "重置為預設配置",
      "panelSettings": "常規",
      "securitySettings": "安全設定",
      "securityWarnings": "安全警告",
      "panelExposed": "您的面板可能已暴露：",
      "warnHttp": "面板透過明文 HTTP 提供服務 — 生產環境請設定 TLS。",
      "warnDefaultPort": "預設連接埠 2053 廣為人知 — 請更改為隨機連接埠。",
      "warnDefaultBasePath": "預設根路徑 \"/\" 廣為人知 — 請更改為隨機路徑。",
      "warnDefaultSubPath": "預設訂閱路徑 \"/sub/\" 廣為人知 — 請更改。",
      "warnDefaultJsonPath": "預設 JSON 訂閱路徑 \"/json/\" 廣為人知 — 請更改。",
      "TGBotSettings": "Telegram 機器人",
      "panelListeningIP": "面板監聽 IP",
      "panelListeningIPDesc": "預設留空監聽所有 IP",
      "panelListeningDomain": "面板監聽域名",
      "panelListeningDomainDesc": "預設情況下留空以監視所有域名和 IP 地址",
      "panelPort": "面板監聽埠",
      "panelPortDesc": "重啟面板生效",
      "publicKeyPath": "面板證書公鑰檔案路徑",
      "publicKeyPathDesc": "填寫一個 '/' 開頭的絕對路徑",
      "privateKeyPath": "面板證書金鑰檔案路徑",
      "privateKeyPathDesc": "填寫一個 '/' 開頭的絕對路徑",
      "panelUrlPath": "URI 路徑",
      "panelUrlPathDesc": "必須以 '/' 開頭，以 '/' 結尾",
      "pageSize": "分頁大小",
      "pageSizeDesc": "定義入站表的頁面大小。設定 0 表示禁用",
      "panelProxy": "面板網路代理",
      "panelProxyDesc": "透過此代理路由面板自身的出站請求(geo 更新、Xray/面板版本檢查、Telegram),以繞過伺服器端對 GitHub/Telegram 的過濾。接受 socks5:// 或 http(s)://,如本地 Xray SOCKS 入站。留空表示直連。",
      "remarkModel": "備註模型和分隔符",
      "datepicker": "日期選擇器",
      "datepickerPlaceholder": "選擇日期",
      "datepickerDescription": "選擇器日曆類型指定到期日期",
      "sampleRemark": "備註示例",
      "oldUsername": "原使用者名稱",
      "currentPassword": "原密碼",
      "newUsername": "新使用者名稱",
      "newPassword": "新密碼",
      "telegramBotEnable": "啟用 Telegram 機器人",
      "telegramBotEnableDesc": "啟用 Telegram 機器人功能",
      "telegramToken": "Telegram Token",
      "telegramTokenDesc": "從 '{'@'}BotFather' 獲取的 Telegram 機器人令牌",
      "telegramProxy": "SOCKS 代理",
      "telegramProxyDesc": "啟用 SOCKS5 代理連線到 Telegram（根據指南調整設定）",
      "telegramAPIServer": "Telegram API 伺服器",
      "telegramAPIServerDesc": "要使用的 Telegram API 伺服器。留空以使用預設伺服器。",
      "telegramChatId": "管理員聊天 ID",
      "telegramChatIdDesc": "Telegram 管理員聊天 ID (多個以逗號分隔)（可通過 {'@'}userinfobot 獲取，或在機器人中使用 '/id' 命令獲取）",
      "telegramNotifyTime": "通知時間",
      "telegramNotifyTimeDesc": "設定週期性的 Telegram 機器人通知時間（使用 crontab 時間格式）",
      "tgNotifyBackup": "資料庫備份",
      "tgNotifyBackupDesc": "傳送帶有報告的資料庫備份檔案",
      "tgNotifyLogin": "登入通知",
      "tgNotifyLoginDesc": "當有人試圖登入你的面板時顯示使用者名稱、IP 地址和時間",
      "sessionMaxAge": "會話時長",
      "sessionMaxAgeDesc": "保持登入狀態的時長（單位：分鐘）",
      "expireTimeDiff": "到期通知閾值",
      "expireTimeDiffDesc": "達到此閾值時，將收到有關到期時間的通知（單位：天）",
      "trafficDiff": "流量耗盡閾值",
      "trafficDiffDesc": "達到此閾值時，將收到有關流量耗盡的通知（單位：GB）",
      "tgNotifyCpu": "CPU 負載通知閾值",
      "tgNotifyCpuDesc": "CPU 負載超過此閾值時，將收到通知（單位：%）",
      "timeZone": "時區",
      "timeZoneDesc": "定時任務將按照該時區的時間執行",
      "subSettings": "訂閱設定",
      "subEnable": "啟用訂閱服務",
      "subEnableDesc": "啟用訂閱服務功能",
      "subJsonEnable": "獨立啟用/停用 JSON 訂閱端點。",
      "subJsonEnableTitle": "JSON 訂閱",
      "subClashEnableTitle": "Clash / Mihomo 訂閱",
      "subTitle": "訂閱標題",
      "subTitleDesc": "在VPN客戶端中顯示的標題",
      "subSupportUrl": "支援連結",
      "subSupportUrlDesc": "VPN 用戶端中顯示的技術支援連結",
      "subProfileUrl": "個人資料連結",
      "subProfileUrlDesc": "VPN 用戶端中顯示的網站連結",
      "subAnnounce": "公告",
      "subAnnounceDesc": "VPN 用戶端中顯示的公告文字",
      "subEnableRouting": "啟用路由",
      "subEnableRoutingDesc": "在 VPN 用戶端中啟用路由的全域設定。（僅限 Happ）",
      "subRoutingRules": "路由規則",
      "subRoutingRulesDesc": "VPN 用戶端的全域路由規則。（僅限 Happ）",
      "subListen": "監聽 IP",
      "subListenDesc": "訂閱服務監聽的 IP 地址（留空表示監聽所有 IP）",
      "subPort": "監聽埠",
      "subPortDesc": "訂閱服務監聽的埠號（必須是未使用的埠）",
      "subCertPath": "公鑰路徑",
      "subCertPathDesc": "訂閱服務使用的公鑰檔案路徑（以 '/' 開頭）",
      "subKeyPath": "私鑰路徑",
      "subKeyPathDesc": "訂閱服務使用的私鑰檔案路徑（以 '/' 開頭）",
      "subPath": "URI 路徑",
      "subPathDesc": "訂閱服務使用的 URI 路徑（以 '/' 開頭，以 '/' 結尾）",
      "subDomain": "監聽域名",
      "subDomainDesc": "訂閱服務監聽的域名（留空表示監聽所有域名和 IP）",
      "subUpdates": "更新間隔",
      "subUpdatesDesc": "客戶端應用中訂閱 URL 的更新間隔（單位：小時）",
      "subEncrypt": "編碼",
      "subEncryptDesc": "訂閱服務返回的內容將採用 Base64 編碼",
      "subShowInfo": "顯示使用資訊",
      "subShowInfoDesc": "客戶端應用中將顯示剩餘流量和日期資訊",
      "subEmailInRemark": "在名稱中包含郵箱",
      "subEmailInRemarkDesc": "在訂閱配置名稱中包含客戶端郵箱。",
      "subURI": "反向代理 URI",
      "subURIDesc": "用於代理後面的訂閱 URL 的 URI 路徑",
      "externalTrafficInformEnable": "外部交通通知",
      "externalTrafficInformEnableDesc": "每次流量更新時通知外部 API。",
      "externalTrafficInformURI": "外部流量通知 URI",
      "externalTrafficInformURIDesc": "流量更新將會傳送到此 URI",
      "restartXrayOnClientDisable": "用戶自動停用後重新啟動 Xray",
      "restartXrayOnClientDisableDesc": "當用戶因到期或流量上限而被自動停用時，重新啟動 Xray。",
      "fragment": "分片",
      "fragmentDesc": "啟用 TLS hello 資料包分片",
      "fragmentSett": "設定",
      "noisesDesc": "啟用 Noises.",
      "noisesSett": "Noises 設定",
      "trustedProxyCidrs": "信任代理 CIDR",
      "trustedProxyCidrsDesc": "允許設定轉發 host、proto 與客戶端 IP 標頭的 IP/CIDR(逗號分隔)。",
      "ldap": {
        "enable": "啟用 LDAP 同步",
        "host": "LDAP host",
        "port": "LDAP 連接埠",
        "useTls": "使用 TLS (LDAPS)",
        "bindDn": "Bind DN",
        "passwordConfigured": "已設定;留空以保留目前密碼。",
        "passwordUnconfigured": "未設定。",
        "passwordPlaceholder": "已設定 - 輸入新值以取代",
        "baseDn": "Base DN",
        "userFilter": "使用者篩選",
        "userAttr": "使用者屬性 (username/email)",
        "vlessField": "VLESS flag 屬性",
        "flagField": "通用 flag 屬性 (選用)",
        "flagFieldDesc": "若設定,將覆寫 VLESS flag — 如 shadowInactive。",
        "truthyValues": "Truthy 值",
        "truthyValuesDesc": "以逗號分隔;預設: true,1,yes,on",
        "invertFlag": "反轉 flag",
        "invertFlagDesc": "當屬性表示已停用時啟用 (如 shadowInactive)。",
        "syncSchedule": "同步排程",
        "syncScheduleDesc": "類 cron 字串,如 @every 1m",
        "inboundTags": "入站標籤",
        "inboundTagsDesc": "允許 LDAP 同步自動建立或刪除客戶端的入站。",
        "noInbounds": "未找到入站。請先在「入站」中建立。",
        "autoCreate": "自動建立客戶端",
        "autoDelete": "自動刪除客戶端",
        "defaultTotalGb": "預設總流量 (GB)",
        "defaultExpiryDays": "預設到期 (天)",
        "defaultIpLimit": "預設 IP 限制"
      },
      "subFormats": {
        "packets": "封包",
        "length": "長度",
        "interval": "間隔",
        "maxSplit": "最大分割",
        "noises": "雜訊",
        "noiseItem": "雜訊 №{n}",
        "type": "類型",
        "packet": "封包",
        "delayMs": "延遲 (ms)",
        "applyTo": "套用至",
        "addNoise": "+ 雜訊",
        "concurrency": "並發",
        "xudpConcurrency": "xudp 並發",
        "xudpUdp443": "xudp UDP 443"
      },
      "mux": "Mux",
      "muxDesc": "在已建立的資料流內傳輸多個獨立的資料流",
      "muxSett": "複用器設定",
      "direct": "直接連線",
      "directDesc": "直接與特定國家的域或IP範圍建立連線",
      "notifications": "通知",
      "certs": "證書",
      "externalTraffic": "外部流量",
      "dateAndTime": "日期和時間",
      "proxyAndServer": "代理和伺服器",
      "intervals": "間隔",
      "information": "資訊",
      "language": "語言",
      "telegramBotLanguage": "Telegram 機器人語言",
      "security": {
        "admin": "管理員憑證",
        "twoFactor": "雙重驗證",
        "twoFactorEnable": "啟用2FA",
        "twoFactorEnableDesc": "增加額外的驗證層以提高安全性。",
        "twoFactorModalSetTitle": "啟用雙重認證",
        "twoFactorModalDeleteTitle": "停用雙重認證",
        "twoFactorModalSteps": "要設定雙重認證，請執行以下步驟：",
        "twoFactorModalFirstStep": "1. 在認證應用程式中掃描此QR碼，或複製QR碼附近的令牌並貼到應用程式中",
        "twoFactorModalSecondStep": "2. 輸入應用程式中的驗證碼",
        "twoFactorModalRemoveStep": "輸入應用程式中的驗證碼以移除雙重認證。",
        "twoFactorModalChangeCredentialsTitle": "更改憑證",
        "twoFactorModalChangeCredentialsStep": "輸入應用程式中的代碼以更改管理員憑證。",
        "twoFactorModalSetSuccess": "雙重身份驗證已成功建立",
        "twoFactorModalDeleteSuccess": "雙重身份驗證已成功刪除",
        "twoFactorModalError": "驗證碼錯誤",
        "show": "顯示",
        "hide": "隱藏",
        "apiTokenNew": "新增令牌",
        "apiTokenName": "名稱",
        "apiTokenNamePlaceholder": "例如 central-panel-a",
        "apiTokenNameRequired": "名稱必填",
        "apiTokenEmpty": "尚無令牌 — 建立一個以認證機器人或遠端面板。",
        "apiTokenDeleteWarning": "使用此令牌的任何呼叫方將立即無法認證。"
      },
      "toasts": {
        "modifySettings": "參數已更改。",
        "getSettings": "取得參數時發生錯誤",
        "modifyUserError": "變更管理員憑證時發生錯誤。",
        "modifyUser": "您已成功變更管理員憑證。",
        "originalUserPassIncorrect": "原使用者名稱或原密碼錯誤",
        "userPassMustBeNotEmpty": "新使用者名稱和新密碼不能為空",
        "getOutboundTrafficError": "取得出站流量錯誤",
        "resetOutboundTrafficError": "重設出站流量錯誤"
      }
    },
    "xray": {
      "title": "Xray 配置",
      "save": "儲存",
      "restart": "重新啟動 Xray",
      "restartSuccess": "Xray 已成功重新啟動",
      "restartOutputTitle": "Xray 重新啟動輸出",
      "restartConfirmTitle": "重新啟動 xray?",
      "restartConfirmContent": "使用已儲存的設定重新載入 xray 服務。",
      "stopSuccess": "Xray 已成功停止",
      "restartError": "重新啟動Xray時發生錯誤。",
      "stopError": "停止Xray時發生錯誤。",
      "basicTemplate": "基礎配置",
      "advancedTemplate": "高階配置",
      "generalConfigs": "常規配置",
      "generalConfigsDesc": "這些選項將決定常規配置",
      "logConfigs": "記錄",
      "logConfigsDesc": "日誌可能會影響伺服器的效能，建議僅在需要時啟用",
      "blockConfigsDesc": "這些選項將阻止使用者連線到特定協議和網站",
      "basicRouting": "基本路由",
      "blockConnectionsConfigsDesc": "這些選項將根據特定的請求國家阻止流量。",
      "directConnectionsConfigsDesc": "直接連線確保特定的流量不會通過其他伺服器路由。",
      "blockips": "阻止IP",
      "blockdomains": "阻止域名",
      "directips": "直接IP",
      "directdomains": "直接域名",
      "ipv4Routing": "IPv4 路由",
      "ipv4RoutingDesc": "此選項將僅通過 IPv4 路由到目標域",
      "warpRouting": "WARP 路由",
      "warpRoutingDesc": "注意：在使用這些選項之前，請按照面板 GitHub 上的步驟在你的伺服器上以 socks5 代理模式安裝 WARP。WARP 將通過 Cloudflare 伺服器將流量路由到網站。",
      "nordRouting": "NordVPN 路由",
      "nordRoutingDesc": "這些選項將根據特定目的地通過 NordVPN 路由流量。",
      "Template": "高階 Xray 配置模板",
      "TemplateDesc": "最終的 Xray 配置檔案將基於此模板生成",
      "FreedomStrategy": "Freedom 協議策略",
      "FreedomStrategyDesc": "設定 Freedom 協議中網路的輸出策略",
      "RoutingStrategy": "配置路由域策略",
      "RoutingStrategyDesc": "設定 DNS 解析的整體路由策略",
      "outboundTestUrl": "出站測試 URL",
      "outboundTestUrlDesc": "測試出站連線時使用的 URL",
      "Torrent": "遮蔽 BitTorrent 協議",
      "Inbounds": "入站",
      "InboundsDesc": "接受來自特定客戶端的流量",
      "Outbounds": "出站",
      "Balancers": "負載均衡",
      "balancerTagRequired": "標籤為必填",
      "balancerSelectorRequired": "至少選擇一個出站",
      "OutboundsDesc": "設定出站流量傳出方式",
      "Routings": "路由規則",
      "RoutingsDesc": "每條規則的優先順序都很重要",
      "completeTemplate": "全部",
      "logLevel": "日誌級別",
      "logLevelDesc": "錯誤日誌的日誌級別，用於指示需要記錄的資訊",
      "accessLog": "訪問日誌",
      "accessLogDesc": "訪問日誌的檔案路徑。特殊值 'none' 禁用訪問日誌",
      "errorLog": "錯誤日誌",
      "errorLogDesc": "錯誤日誌的檔案路徑。特殊值 'none' 禁用錯誤日誌",
      "dnsLog": "DNS 日誌",
      "dnsLogDesc": "是否啟用 DNS 查詢日誌",
      "maskAddress": "隱藏地址",
      "maskAddressDesc": "IP 地址掩碼，啟用時會自動替換日誌中出現的 IP 地址。",
      "statistics": "統計",
      "statsInboundUplink": "入站上傳統計",
      "statsInboundUplinkDesc": "啟用所有入站代理的上行流量統計收集。",
      "statsInboundDownlink": "入站下載統計",
      "statsInboundDownlinkDesc": "啟用所有入站代理的下行流量統計收集。",
      "statsOutboundUplink": "出站上傳統計",
      "statsOutboundUplinkDesc": "啟用所有出站代理的上行流量統計收集。",
      "statsOutboundDownlink": "出站下載統計",
      "statsOutboundDownlinkDesc": "啟用所有出站代理的下行流量統計收集。",
      "rules": {
        "first": "置頂",
        "last": "置底",
        "up": "向上",
        "down": "向下",
        "source": "來源",
        "dest": "目的地址",
        "inbound": "入站",
        "outbound": "出站",
        "balancer": "負載均衡",
        "info": "資訊",
        "add": "新增規則",
        "edit": "編輯規則",
        "useComma": "逗號分隔的項目"
      },
      "routing": {
        "dragToReorder": "拖曳以重新排序"
      },
      "ruleForm": {
        "sourceIps": "來源 IP",
        "sourcePort": "來源連接埠",
        "vlessRoute": "VLESS 路由",
        "attributes": "屬性",
        "value": "值",
        "user": "使用者",
        "inboundTags": "入站標籤",
        "outboundTag": "出站標籤",
        "balancerTag": "均衡器標籤",
        "balancerTagTooltip": "透過其中一個已設定的負載均衡器路由流量"
      },
      "outboundForm": {
        "tagDuplicate": "該標籤已被其他出站使用",
        "tagRequired": "標籤為必填",
        "tagPlaceholder": "唯一標籤",
        "localIpPlaceholder": "本地 IP",
        "addressRequired": "地址為必填",
        "portRequired": "連接埠為必填",
        "optional": "選用",
        "udpOverTcp": "UDP over TCP",
        "uotVersion": "UoT 版本",
        "inboundTag": "入站標籤",
        "inboundTagPlaceholder": "用於路由規則的入站標籤",
        "responseType": "回應類型",
        "rewriteNetwork": "改寫網路",
        "unchanged": "(未變更)",
        "unchangedAddress": "(未變更) 如 1.1.1.1",
        "rules": "規則",
        "ruleN": "規則 {n}",
        "action": "動作",
        "redirect": "Redirect",
        "fragment": "Fragment",
        "finalRules": "最終規則",
        "overrideXrayPrivateIp": "覆寫 Xray 預設的私有 IP 封鎖",
        "blockDelay": "阻斷延遲 (ms)",
        "reverseSniffing": "反向 sniffing",
        "workers": "Workers",
        "reserved": "保留",
        "minUploadInterval": "最小上傳間隔 (ms)",
        "maxUploadSizeBytes": "最大上傳大小 (位元組)",
        "uplinkChunkSize": "Uplink chunk 大小",
        "noGrpcHeader": "無 gRPC 標頭",
        "maxConcurrency": "最大並發",
        "maxConnections": "最大連線",
        "maxReuseTimes": "最大重用次數",
        "maxRequestTimes": "最大請求次數",
        "maxReusableSecs": "最大可重用秒數",
        "keepAlivePeriod": "keep alive 週期",
        "authPassword": "認證密碼",
        "visionTestpre": "Vision testpre",
        "serverNamePlaceholder": "伺服器名稱",
        "verifyPeerName": "驗證 peer 名稱",
        "pinnedSha256": "Pinned SHA256",
        "shortId": "Short ID",
        "sockopts": "Sockopts",
        "keepAliveInterval": "keep alive 間隔",
        "markFwmark": "Mark (fwmark)",
        "interface": "介面",
        "ipv6Only": "僅 IPv6",
        "acceptProxyProtocol": "接受 proxy protocol",
        "tcpUserTimeoutMs": "TCP user timeout (ms)",
        "tcpKeepAliveIdleS": "TCP keep-alive idle (s)"
      },
      "outbound": {
        "addOutbound": "新增出站",
        "addReverse": "新增反向",
        "editOutbound": "編輯出站",
        "editReverse": "編輯反向",
        "reverseTag": "反向標籤",
        "reverseTagDesc": "VLESS 簡易反向代理出站標籤。留空則停用。設定後，此客戶端的連線可作為反向代理隧道。",
        "reverseTagPlaceholder": "出站標籤（留空則停用）",
        "tag": "標籤",
        "tagDesc": "唯一標籤",
        "address": "地址",
        "reverse": "反向",
        "domain": "網域",
        "type": "類型",
        "bridge": "Bridge",
        "portal": "Portal",
        "link": "連結",
        "intercon": "互連",
        "settings": "設定",
        "accountInfo": "帳戶資訊",
        "outboundStatus": "出站狀態",
        "sendThrough": "傳送通過",
        "test": "測試",
        "testResult": "測試結果",
        "testing": "正在測試連接...",
        "testSuccess": "測試成功",
        "testFailed": "測試失敗",
        "testError": "測試出站失敗",
        "testModeTooltip": "TCP: 快速 dial-only 探測。HTTP: 透過 xray 的完整請求。",
        "testAll": "全部測試",
        "nordvpn": "NordVPN",
        "accessToken": "訪問令牌",
        "country": "國家",
        "server": "伺服器",
        "city": "城市",
        "allCities": "所有城市",
        "privateKey": "私密金鑰",
        "load": "負載"
      },
      "balancer": {
        "addBalancer": "新增負載均衡",
        "editBalancer": "編輯負載均衡",
        "balancerStrategy": "策略",
        "balancerSelectors": "選擇器",
        "tag": "標籤",
        "tagDesc": "唯一標籤",
        "tagDuplicate": "該標籤已被其他均衡器使用",
        "tagPlaceholder": "唯一均衡器標籤",
        "selector": "選擇器",
        "fallback": "Fallback",
        "expected": "期望",
        "expectedPlaceholder": "最佳節點數",
        "maxRtt": "最大 RTT",
        "tolerance": "容差",
        "baselines": "Baselines",
        "costs": "Costs",
        "balancerDesc": "無法同時使用 balancerTag 和 outboundTag。如果同時使用，則只有 outboundTag 會生效。"
      },
      "wireguard": {
        "secretKey": "金鑰",
        "publicKey": "公鑰",
        "allowedIPs": "允許的 IP",
        "endpoint": "端點",
        "psk": "共享金鑰",
        "domainStrategy": "域策略"
      },
      "tun": {
        "nameDesc": "TUN 介面的名稱。預設值為 'xray0'",
        "mtuDesc": "最大傳輸單元。資料包的最大大小。預設值為 1500",
        "userLevel": "用戶級別",
        "userLevelDesc": "通過此入站的所有連接都將使用此用戶級別。預設值為 0"
      },
      "nord": {
        "accessToken": "Access token",
        "privateKey": "私鑰",
        "noServers": "未找到選定國家/地區的伺服器",
        "noPublicKey": "選定的伺服器未公布 NordLynx 公鑰。",
        "outboundAdded": "NordVPN 出站已新增",
        "outboundUpdated": "NordVPN 出站已更新"
      },
      "warp": {
        "licenseError": "設定 WARP 授權失敗。",
        "fetchFirst": "請先取得 WARP 設定。",
        "createAccount": "建立 WARP 帳號",
        "accessToken": "Access token",
        "deviceId": "裝置 ID",
        "licenseKey": "授權金鑰",
        "privateKey": "私鑰",
        "deleteAccount": "刪除帳號",
        "settings": "設定",
        "licenseKeyLabel": "WARP / WARP+ 授權金鑰",
        "key": "金鑰",
        "keyPlaceholder": "26 位 WARP+ 金鑰",
        "accountInfo": "帳號資訊",
        "deviceName": "裝置名稱",
        "deviceModel": "裝置型號",
        "deviceEnabled": "裝置已啟用",
        "accountType": "帳號類型",
        "role": "角色",
        "warpPlusData": "WARP+ 資料",
        "quota": "配額",
        "usage": "使用",
        "addOutbound": "新增出站"
      },
      "dns": {
        "enable": "啟用 DNS",
        "enableDesc": "啟用內建 DNS 伺服器",
        "tag": "DNS 入站標籤",
        "tagDesc": "此標籤將在路由規則中可用作入站標籤",
        "clientIp": "客戶端IP",
        "clientIpDesc": "用於在DNS查詢期間通知伺服器指定的IP位置",
        "disableCache": "禁用快取",
        "disableCacheDesc": "禁用DNS快取",
        "disableFallback": "禁用回退",
        "disableFallbackDesc": "禁用回退DNS查詢",
        "disableFallbackIfMatch": "匹配時禁用回退",
        "disableFallbackIfMatchDesc": "當DNS伺服器的匹配域名列表命中時，禁用回退DNS查詢",
        "enableParallelQuery": "啟用並行查詢",
        "enableParallelQueryDesc": "啟用並行DNS查詢到多個伺服器以實現更快的解析",
        "strategy": "查詢策略",
        "strategyDesc": "解析域名的總體策略",
        "add": "新增伺服器",
        "edit": "編輯伺服器",
        "domains": "網域",
        "expectIPs": "預期 IP",
        "unexpectIPs": "意外IP",
        "useSystemHosts": "使用系統Hosts",
        "useSystemHostsDesc": "使用已安裝系統的hosts檔案",
        "serveStale": "提供過期結果",
        "serveStaleDesc": "在背景重新整理時傳回過期的快取結果",
        "serveExpiredTTL": "過期TTL",
        "serveExpiredTTLDesc": "過期快取項目的有效期（秒）；0 = 永不過期",
        "timeoutMs": "逾時 (毫秒)",
        "skipFallback": "跳過回退",
        "finalQuery": "最終查詢",
        "hosts": "Hosts",
        "hostsAdd": "新增 Host",
        "hostsEmpty": "未定義任何 Host",
        "hostsDomain": "網域 (例如 domain:example.com)",
        "hostsValues": "IP 或網域 — 輸入後按 Enter",
        "usePreset": "使用範本",
        "dnsPresetTitle": "DNS範本",
        "dnsPresetFamily": "家庭",
        "clearAll": "全部刪除",
        "clearAllTitle": "刪除所有 DNS 伺服器？",
        "clearAllConfirm": "此操作將從清單中刪除所有 DNS 伺服器，無法復原。"
      },
      "fakedns": {
        "add": "新增假 DNS",
        "edit": "編輯假 DNS",
        "ipPool": "IP 池子網",
        "poolSize": "池大小"
      }
    }
  },
  "tgbot": {
    "keyboardClosed": "❌ 自定義鍵盤已關閉！",
    "noResult": "❗ 沒有結果！",
    "noQuery": "❌ 未找到查詢！請再次使用該命令！",
    "wentWrong": "❌ 出了點問題！",
    "noIpRecord": "❗ 沒有IP記錄！",
    "noInbounds": "❗ 未找到入站！",
    "unlimited": "♾ 無限（重置）",
    "add": "添加",
    "month": "月",
    "months": "月",
    "day": "天",
    "days": "天",
    "hours": "小時",
    "minutes": "分鐘",
    "unknown": "未知",
    "inbounds": "入站",
    "clients": "客戶端",
    "offline": "🔴 離線",
    "online": "🟢 上線",
    "commands": {
      "unknown": "❗ 未知命令",
      "pleaseChoose": "👇 請選擇：\r\n",
      "help": "🤖 歡迎使用本機器人！它旨在為您提供來自伺服器的特定資料，並允許您進行必要的修改。\r\n\r\n",
      "start": "👋 你好，<i>{{ .Firstname }}</i>。\r\n",
      "welcome": "🤖 歡迎來到 <b>{{ .Hostname }}</b> 管理機器人。\r\n",
      "status": "✅ 機器人正常執行！",
      "usage": "❗ 請輸入要搜尋的文字！",
      "getID": "🆔 您的 ID 為：<code>{{ .ID }}</code>",
      "helpAdminCommands": "要重新啟動 Xray Core：\r\n<code>/restart</code>\r\n\r\n要搜尋客戶電子郵件：\r\n<code>/usage [電子郵件]</code>\r\n\r\n要搜尋入站（帶有客戶統計資料）：\r\n<code>/inbound [備註]</code>\r\n\r\nTelegram聊天ID：\r\n<code>/id</code>",
      "helpClientCommands": "要搜尋統計資料，請使用以下命令：\r\n<code>/usage [電子郵件]</code>\r\n\r\nTelegram聊天ID：\r\n<code>/id</code>",
      "restartUsage": "\r\n\r\n<code>/restart</code>",
      "restartSuccess": "✅ 操作成功!",
      "restartFailed": "❗ 操作錯誤。\r\n\r\n<code>錯誤: {{ .Error }}</code>.",
      "xrayNotRunning": "❗ Xray Core 未運行。",
      "startDesc": "顯示主選單",
      "helpDesc": "機器人幫助",
      "statusDesc": "檢查機器人狀態",
      "idDesc": "顯示您的 Telegram ID"
    },
    "messages": {
      "cpuThreshold": "🔴 CPU 使用率為 {{ .Percent }}%，超過閾值 {{ .Threshold }}%",
      "selectUserFailed": "❌ 使用者選擇錯誤！",
      "userSaved": "✅ 電報使用者已儲存。",
      "loginSuccess": "✅ 成功登入到面板。\r\n",
      "loginFailed": "❗️ 面板登入失敗。\r\n",
      "2faFailed": "2FA 失敗",
      "report": "🕰 定時報告：{{ .RunTime }}\r\n",
      "datetime": "⏰ 日期時間：{{ .DateTime }}\r\n",
      "hostname": "💻 主機: {{ .Hostname }}\r\n",
      "version": "🚀 X-UI 版本：{{ .Version }}\r\n",
      "xrayVersion": "📡 Xray 版本: {{ .XrayVersion }}\r\n",
      "ipv6": "🌐 IPv6: {{ .IPv6 }}\r\n",
      "ipv4": "🌐 IPv4: {{ .IPv4 }}\r\n",
      "ip": "🌐 IP: {{ .IP }}\r\n",
      "ips": "🔢 IPs:\r\n{{ .IPs }}\r\n",
      "serverUpTime": "⏳ 伺服器執行時間：{{ .UpTime }} {{ .Unit }}\r\n",
      "serverLoad": "📈 伺服器負載：{{ .Load1 }}, {{ .Load2 }}, {{ .Load3 }}\r\n",
      "serverMemory": "📋 RAM: {{ .Current }}/{{ .Total }}\r\n",
      "tcpCount": "🔹 TCP: {{ .Count }}\r\n",
      "udpCount": "🔸 UDP: {{ .Count }}\r\n",
      "traffic": "🚦 流量：{{ .Total }} (↑{{ .Upload }},↓{{ .Download }})\r\n",
      "xrayStatus": "ℹ️ 狀態: {{ .State }}\r\n",
      "username": "👤 使用者名稱：{{ .Username }}\r\n",
      "reason": "❗️ 原因：{{ .Reason }}\r\n",
      "time": "⏰ 時間：{{ .Time }}\r\n",
      "inbound": "📍 入站: {{ .Remark }}\r\n",
      "port": "🔌 連接埠: {{ .Port }}\r\n",
      "expire": "📅 過期日期：{{ .Time }}\r\n",
      "expireIn": "📅 剩餘時間：{{ .Time }}\r\n",
      "active": "💡 啟用：{{ .Enable }}\r\n",
      "enabled": "🚨 已啟用：{{ .Enable }}\r\n",
      "online": "🌐 連線狀態：{{ .Status }}\r\n",
      "lastOnline": "🔙 上次上線: {{ .Time }}\r\n",
      "email": "📧 電子郵件: {{ .Email }}\r\n",
      "upload": "🔼 上傳: ↑{{ .Upload }}\r\n",
      "download": "🔽 下載: ↓{{ .Download }}\r\n",
      "total": "📊 總計: ↑↓{{ .UpDown }} / {{ .Total }}\r\n",
      "TGUser": "👤 電報使用者：{{ .TelegramID }}\r\n",
      "exhaustedMsg": "🚨 耗盡的 {{ .Type }}：\r\n",
      "exhaustedCount": "🚨 耗盡的 {{ .Type }} 數量：\r\n",
      "onlinesCount": "🌐 線上客戶：{{ .Count }}\r\n",
      "disabled": "🛑 禁用：{{ .Disabled }}\r\n",
      "depleteSoon": "🔜 即將耗盡：{{ .Deplete }}\r\n\r\n",
      "backupTime": "🗄 備份時間：{{ .Time }}\r\n",
      "refreshedOn": "\r\n📋🔄 重新整理時間：{{ .Time }}\r\n\r\n",
      "yes": "✅ 是的",
      "no": "❌ 否",
      "received_id": "🔑📥 ID 已更新。",
      "received_password": "🔑📥 密碼已更新。",
      "received_email": "📧📥 電子郵件已更新。",
      "received_comment": "💬📥 評論已更新。",
      "id_prompt": "🔑 預設 ID: {{ .ClientId }}\n\n請輸入您的 ID。",
      "pass_prompt": "🔑 預設密碼: {{ .ClientPassword }}\n\n請輸入您的密碼。",
      "email_prompt": "📧 預設電子郵件: {{ .ClientEmail }}\n\n請輸入您的電子郵件。",
      "comment_prompt": "💬 預設評論: {{ .ClientComment }}\n\n請輸入您的評論。",
      "inbound_client_data_id": "🔄 入站: {{ .InboundRemark }}\n\n🔑 ID: {{ .ClientId }}\n📧 電子郵件: {{ .ClientEmail }}\n📊 流量: {{ .ClientTraffic }}\n📅 到期日: {{ .ClientExp }}\n🌐 IP 限制: {{ .IpLimit }}\n💬 備註: {{ .ClientComment }}\n\n你現在可以將客戶加入入站了！",
      "inbound_client_data_pass": "🔄 入站: {{ .InboundRemark }}\n\n🔑 密碼: {{ .ClientPass }}\n📧 電子郵件: {{ .ClientEmail }}\n📊 流量: {{ .ClientTraffic }}\n📅 到期日: {{ .ClientExp }}\n🌐 IP 限制: {{ .IpLimit }}\n💬 備註: {{ .ClientComment }}\n\n你現在可以將客戶加入入站了！",
      "cancel": "❌ 程序已取消！\n\n您可以隨時使用 /start 重新開始。 🔄",
      "error_add_client": "⚠️ 錯誤:\n\n {{ .error }}",
      "using_default_value": "好的，我會使用預設值。 😊",
      "incorrect_input": "您的輸入無效。\n短語應連續輸入，不能有空格。\n正確示例: aaaaaa\n錯誤示例: aaa aaa 🚫",
      "AreYouSure": "你確定嗎？🤔",
      "SuccessResetTraffic": "📧 電子郵件: {{ .ClientEmail }}\n🏁 結果: ✅ 成功",
      "FailedResetTraffic": "📧 電子郵件: {{ .ClientEmail }}\n🏁 結果: ❌ 失敗 \n\n🛠️ 錯誤: [ {{ .ErrorMessage }} ]",
      "FinishProcess": "🔚 所有客戶的流量重置已完成。"
    },
    "buttons": {
      "closeKeyboard": "❌ 關閉鍵盤",
      "cancel": "❌ 取消",
      "cancelReset": "❌ 取消重置",
      "cancelIpLimit": "❌ 取消 IP 限制",
      "confirmResetTraffic": "✅ 確認重置流量？",
      "confirmClearIps": "✅ 確認清除 IP？",
      "confirmRemoveTGUser": "✅ 確認移除 Telegram 使用者？",
      "confirmToggle": "✅ 確認啟用/禁用使用者？",
      "dbBackup": "獲取資料庫備份",
      "serverUsage": "伺服器使用情況",
      "getInbounds": "獲取入站資訊",
      "depleteSoon": "即將耗盡",
      "clientUsage": "獲取使用情況",
      "onlines": "線上客戶端",
      "commands": "命令",
      "refresh": "🔄 重新整理",
      "clearIPs": "❌ 清除 IP",
      "removeTGUser": "❌ 移除 Telegram 使用者",
      "selectTGUser": "👤 選擇 Telegram 使用者",
      "selectOneTGUser": "👤 選擇一個 Telegram 使用者：",
      "resetTraffic": "📈 重置流量",
      "resetExpire": "📅 更改到期日期",
      "ipLog": "🔢 IP 日誌",
      "ipLimit": "🔢 IP 限制",
      "setTGUser": "👤 設定 Telegram 使用者",
      "toggle": "🔘 啟用/禁用",
      "custom": "🔢 自訂",
      "confirmNumber": "✅ 確認: {{ .Num }}",
      "confirmNumberAdd": "✅ 確認新增：{{ .Num }}",
      "limitTraffic": "🚧 流量限制",
      "getBanLogs": "禁止日誌",
      "allClients": "所有客戶",
      "addClient": "新增客戶",
      "submitDisable": "以停用方式送出 ☑️",
      "submitEnable": "以啟用方式送出 ✅",
      "use_default": "🏷️ 使用預設值",
      "change_id": "⚙️🔑 ID",
      "change_password": "⚙️🔑 密碼",
      "change_email": "⚙️📧 電子郵件",
      "change_comment": "⚙️💬 評論",
      "change_flow": "⚙️🚦 Flow",
      "ResetAllTraffics": "重設所有流量",
      "SortedTrafficUsageReport": "排序過的流量使用報告"
    },
    "answers": {
      "successfulOperation": "✅ 成功！",
      "errorOperation": "❗ 操作錯誤。",
      "getInboundsFailed": "❌ 獲取入站資訊失敗。",
      "getClientsFailed": "❌ 獲取客戶失敗。",
      "canceled": "❌ {{ .Email }}：操作已取消。",
      "clientRefreshSuccess": "✅ {{ .Email }}：客戶端重新整理成功。",
      "IpRefreshSuccess": "✅ {{ .Email }}：IP 重新整理成功。",
      "TGIdRefreshSuccess": "✅ {{ .Email }}：客戶端的 Telegram 使用者重新整理成功。",
      "resetTrafficSuccess": "✅ {{ .Email }}：流量已重置成功。",
      "setTrafficLimitSuccess": "✅ {{ .Email }}: 流量限制儲存成功。",
      "expireResetSuccess": "✅ {{ .Email }}：過期天數已重置成功。",
      "resetIpSuccess": "✅ {{ .Email }}：成功儲存 IP 限制數量為 {{ .Count }}。",
      "clearIpSuccess": "✅ {{ .Email }}：IP 已成功清除。",
      "getIpLog": "✅ {{ .Email }}：獲取 IP 日誌。",
      "getUserInfo": "✅ {{ .Email }}：獲取 Telegram 使用者資訊。",
      "removedTGUserSuccess": "✅ {{ .Email }}：Telegram 使用者已成功移除。",
      "enableSuccess": "✅ {{ .Email }}：已成功啟用。",
      "disableSuccess": "✅ {{ .Email }}：已成功禁用。",
      "askToAddUserId": "未找到您的配置！\r\n請向管理員詢問，在您的配置中使用您的 Telegram 使用者 ChatID。\r\n\r\n您的使用者 ChatID：<code>{{ .TgUserID }}</code>",
      "chooseClient": "為入站 {{ .Inbound }} 選擇一個客戶",
      "chooseInbound": "選擇一個入站"
    }
  }
}
